import { isUndefined, omitBy } from 'lodash';
import { get, patch, post } from '../../utils/http';

export const addClientLocation = ({ accountId, clientId, clientBranchId, location }) =>
  post(`/accounts/${accountId}/clients/${clientId}/branches/${clientBranchId}/locations`, { ...location });

export const fetchClientSpecificLocation = ({ accountId, clientId, clientBranchId, locationId, withAttachments }) =>
  get(`/accounts/${accountId}/clients/${clientId}/branches/${clientBranchId}/locations/${locationId}`, {
    withAttachments
  });

export const updateClientLocation = ({
  accountId,
  clientId,
  clientBranchId,
  locationId,
  location: { name, photo, lat, lng, address, subLocations }
}) =>
  patch(
    `/accounts/${accountId}/clients/${clientId}/branches/${clientBranchId}/locations/${locationId}`,
    omitBy({ name, lat, lng, address, photo, subLocations }, isUndefined)
  );
